import script from "./FontSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./FontSetting.vue?vue&type=script&setup=true&lang=js"

import "./FontSetting.vue?vue&type=style&index=0&id=622b1e35&lang=scss"

const __exports__ = script;

export default __exports__